export const Add_JUDGE = 'Add_JUDGE'
export const UPDATE_JUDGE = 'UPDATE_JUDGE'
export const Add_JUDGE_SUCCESS = 'Add_JUDGE_SUCCESS'
export const LISTING_JUDGE = 'LISTING_JUDGE'
export const ALL_LISTING_JUDGE = 'ALL_LISTING_JUDGE'
export const DELETE_JUDGE = 'DELETE_JUDGE'
export const LISTING_JUDGE_SUCCESS = 'LISTING_JUDGE_SUCCESS'
